import loadable from '@loadable/component';

const LoadableButtonLayer = loadable(
  () => import('../../../../components/Showcase/ButtonLayer/ButtonLayer'),
);

export default LoadableButtonLayer;
